// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2zUko","boxTitle":"Qualiphy_boxTitle__3lhbm","box":"Qualiphy_box__2jXcQ","toggleWrap":"Qualiphy_toggleWrap__1HyRW"};